import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import ComponentErrorBoundary from "@danishagro/shared/src/components/molecules/ErrorBoundary/ComponentErrorBoundary.component";
import { DA_ProductRelewiseList } from "@templates/Relewise";
import { DA_ProductRelewiseListSiloAndHouse } from "@templates/RelewiseSiloAndHouse";
import { useRelewise } from "@danishagro/shared/src/contexts/relewise.context";
import BlockRenderer from "./BlockRenderer";

interface BlockData {
    alias: string;
    key: string;
    version?: string;
    props?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface DynamicBlocksRendererProps {
    blocks: BlockData[];
}

export const DynamicBlocksRenderer: React.FC<DynamicBlocksRendererProps> = ({ blocks }) => {
    const { categoryId } = useRelewise();

    if (!blocks || !blocks.length) return null;

    return (
        <div>
            {blocks.map((block) => {
                // Handle blockContentPLP with container wrapping and prop mapping
                if (block.alias === "blockContentPLP" && block.props?.inriverChannelNodeId) {
                    // Wait until Relewise context has the categoryId set
                    if (categoryId !== block.props.inriverChannelNodeId) return null;

                    return (
                        <ComponentErrorBoundary key={block.key} componentName={block.alias}>
                            <DA_Container>
                                <div style={{ marginTop: "30px" }}>
                                    <DA_ProductRelewiseList
                                        categoryId={block.props.inriverChannelNodeId}
                                        {...block.props}
                                        version={block.version}
                                    />
                                </div>
                            </DA_Container>
                        </ComponentErrorBoundary>
                    );
                }

                // Handle blockContentPLPSiloHouses — same pattern, SiloAndHouse list component
                if (
                    block.alias === "blockContentPLPSiloHouses" &&
                    block.props?.inriverChannelNodeId
                ) {
                    if (categoryId !== block.props.inriverChannelNodeId) return null;

                    return (
                        <ComponentErrorBoundary key={block.key} componentName={block.alias}>
                            <DA_Container>
                                <div style={{ marginTop: "30px" }}>
                                    <DA_ProductRelewiseListSiloAndHouse
                                        categoryId={block.props.inriverChannelNodeId}
                                        {...block.props}
                                        version={block.version}
                                    />
                                </div>
                            </DA_Container>
                        </ComponentErrorBoundary>
                    );
                }

                // If a block has a "type" property, rename it to sliderType.
                const finalProps = block.props?.type
                    ? { ...block.props, sliderType: block.props.type }
                    : block.props;
                // Pass the adjusted props into BlockRenderer.
                return <BlockRenderer key={block.key} block={{ ...block, props: finalProps }} />;
            })}
        </div>
    );
};
